import React, { useCallback, useEffect, useState } from "react";

import type { SolverSettingsModalProps } from "@/components/modals/SolverSettingsModal.types.ts";
import type { DepartmentConfigs, SolverBaseOptions, SolverBlockLogicOptions, SolverConfigs, SolverConstructionHeuristicOptions, SolverMandatoryEntityOptions, SolverPhase } from "@/types.ts";
import type { SolverSettingOptionsController, SolverSettingsOptionsProps } from "@/components/sections/SolverSettingsOptions.types.tsx";
import type { SolverPhasesController, SolverPhasesProps } from "@/components/sections/SolverPhases.types.tsx";
import { PlusCircle, Settings, ChevronRight,Tags, Users} from "lucide-react";
import type { SolverPhaseConfigController, SolverPhaseConfigProps } from "@/components/sections/SolverPhaseConfig.types.tsx";
import Input from "@/components/forms/Input.tsx";
import SolverSettingsModal from "@/components/modals/SolverSettingsModal.tsx";
import SolverPhaseNeedsModal from "@/components/modals/SolverPhaseNeedsModal.tsx";
import SolverPhaseEmployeesModal from "@/components/modals/SolverPhaseEmployeesModal.tsx";

// function safeParseInputTimeSecondsToMilli(seconds:string):number{
//     const parseSeconds = parseFloat(seconds||"0");
//     if(isNaN(parseSeconds))return 0;
//     return Math.floor(parseSeconds * 1000);
// }

// function safeParseInputIntNumber(seconds:string):number{
//     const parseSeconds = parseFloat(seconds||"0");
//     if(isNaN(parseSeconds))return 0;
//     return Math.floor(parseSeconds);
// }

// function initOptionNumber(value:number | undefined | null, defaultInitValue:number):number{
//     if(value === void 0  || value ===null)return defaultInitValue;
//     return value
// }




const InputGroupWrapper: React.FC<{children: React.ReactNode , onClick? : ()=>void}> = (props)=>{
    return <div 
        onClick={props.onClick}
        className={`p-4 border-1 border-gray-300 rounded-sm my-2` + (props.onClick ? ' cursor-pointer' : '')}>
        {props.children}
    </div>
}


const RadioButton: React.FC<{
    checked: boolean,
    onChange:React.ChangeEventHandler<HTMLInputElement, HTMLInputElement> | undefined
}> = (props)=>{
    return <input
        type="radio"
        checked={props.checked}
        disabled={false}
        onChange={props.onChange}
        className="h-4 w-4 accent-blue-600"
    />
}


const PhaseInner: React.FC<{
    title : string,
    checked: boolean,
    onChange:React.ChangeEventHandler<HTMLInputElement, HTMLInputElement> | undefined
    //children: React.ReactNode
}> = (props)=>{
    return <div className="flex items-center gap-2">
        <RadioButton
            checked={props.checked}
            onChange={props.onChange}
        />
        <span className={`text-sm`}>{props.title}</span>
    </div>
}







export function buildSolverPhaseConfigController(
    phase  : SolverPhase | undefined,
    phaseId?:string,
) : SolverPhaseConfigController{

    const [editData , setEditData] = useState({...{},...phase});

    //var entries =Object.entries(editData.mapOfNeedSettings || {});

  //  var listOfUINeeds:SolverPhasesController["viewData"]["listOfUIPhases"] = [];

    // for (const [key, value] of entries) {
    //     if(value && value.active !== false){
    //         listOfUINeeds.push({
    //             name : value.name || "-",
    //             id : key,
    //             phase : value
    //         });
    //     }
    // }


    const viewData:SolverPhaseConfigController["viewData"] = {
        phaseId : phaseId,
        phase : editData,
        isNew : !(!!phase && !!phaseId),
        name : (editData).name ||""
    }

    const changeName  = (name:string)=>{
        setEditData({
            ...{},
            ...editData,
            ...{
                name : name
            }
        })
    }

    return {
        setEditData,
        editData,
        viewData,
        changeName

    }
}


/**
 * Main component
 * @param param0
 * @returns 
 */
const SolverPhaseConfig: React.FC<SolverPhaseConfigProps> = (props) => {

    //const [editData , setEditData] = useState({...{},...solverConfigs});
    const [confirmOpenPhaseSettingModal, setConfirmOpenPhaseSettingModal] = useState(false);
    const [confirmOpenPhaseNeedsModal, setConfirmOpenPhaseNeedsModal] = useState(false);
    const [confirmOpenPhaseEmployeesModal, setConfirmOpenPhaseEmployeesModal] = useState(false);
    const ctrl =props.controller;
    const setEditData = ctrl.setEditData;
    const editData = ctrl.editData;
    const viewData = ctrl.viewData;

    const selectSolverConfig =  (()=>{
        setConfirmOpenPhaseSettingModal(true)
    });
        const selectPhaseNeeds =  (()=>{
        setConfirmOpenPhaseNeedsModal(true)
    });
    const selectPhaseEmployees =  (()=>{
        setConfirmOpenPhaseEmployeesModal(true)
    });

   // ctrl.viewData.
    const LABEL_SOLVER_PARAMS ="Paramètres du solveur";
    const LABEL_SOLVER_NEEDS = 'Besoins';
    const LABEL_SOLVER_EMPLOYEES = 'Employés';

    //@ Counted against the current employees so this badge cannot drift from the selection modal
    const knownUserIds = new Set((props.schedule?.employees || []).map((employee) => employee.userId));
    const selectedEmployeeCount = Object.entries(editData.mapOfEmployeeSettings || {})
        .filter(([userId, settings]) => settings?.apply === true && knownUserIds.has(userId)).length;
    return (
         <div className="text-gray-700">
                
                <div>  
                    <div>
                        <span className="text-sm font-medium">Nom</span>
                    </div>
                    <Input
                        id="phase_name"
                        style={{width:"100%"}}
                        type="text"
                        value={viewData.name}
                        onChange={(e) => {
                            ctrl.changeName(e.target.value);
                    
                           // setTempStartDate(e.target.value);
                          //  setErrorMessage(null);
                        }}
                        className="w-40"
                    />
                </div>
                        <br></br>

                <InputGroupWrapper onClick={selectPhaseNeeds}>
                    <div className="flex items-center gap-2">
                        <Tags />
                        <span className={`text-sm`}>{LABEL_SOLVER_NEEDS}</span>
                        <div className="ml-auto"> <ChevronRight /></div>
                    </div>
                </InputGroupWrapper>
                <InputGroupWrapper onClick={selectPhaseEmployees}>
                    <div className="flex items-center gap-2">
                        <Users />
                        <span className={`text-sm`}>{LABEL_SOLVER_EMPLOYEES}</span>
                        <span className="text-xs text-gray-500">
                            {selectedEmployeeCount > 0 ? `${selectedEmployeeCount} sélectionné(s)` : "Tous"}
                        </span>
                        <div className="ml-auto"> <ChevronRight /></div>
                    </div>
                </InputGroupWrapper>
                <InputGroupWrapper onClick={selectSolverConfig}>
                    <div className="flex items-center gap-2">
                        <Settings />
                        <span className={`text-sm`}>{LABEL_SOLVER_PARAMS}</span>
                         <div className="ml-auto"> <ChevronRight /></div>

                    </div>
                </InputGroupWrapper>

                <SolverSettingsModal
                    open={confirmOpenPhaseSettingModal}
                    onClose={() => setConfirmOpenPhaseSettingModal(false)}
                    onConfirm={async (editData)=>{
                        setEditData({
                            ...{},
                            ...ctrl.editData,
                            ...editData
                        });
                        //await updateSolverConfigs(editData);
                       // onUpdateSolverConfigs();
                    }}
                    title={LABEL_SOLVER_PARAMS}
                    confirmDisabled={false}
                    solverConfigs={viewData.phase}
        
                /> 

                <SolverPhaseNeedsModal
                    schedule={props.schedule}
                    open={confirmOpenPhaseNeedsModal}
                    onClose={() => setConfirmOpenPhaseNeedsModal(false)}
                    onConfirm={async (editData)=>{
                        setEditData({
                            ...{},
                            ...ctrl.editData,
                            ...({
                                mapOfNeedSettings : editData.mapOfNeedSettings ||{}
                            })
                        });
                    }}
                    title={LABEL_SOLVER_NEEDS}
                    confirmDisabled={false}
                    phase={viewData.phase}
                    phaseId={viewData.phaseId}

                />

                <SolverPhaseEmployeesModal
                    schedule={props.schedule}
                    open={confirmOpenPhaseEmployeesModal}
                    onClose={() => setConfirmOpenPhaseEmployeesModal(false)}
                    onConfirm={async (editData)=>{
                        setEditData({
                            ...{},
                            ...ctrl.editData,
                            ...({
                                mapOfEmployeeSettings : editData.mapOfEmployeeSettings ||{}
                            })
                        });
                    }}
                    title="Sélection des employés"
                    confirmDisabled={false}
                    phase={viewData.phase}
                    phaseId={viewData.phaseId}

                />

    



         </div>
    );
};

export default SolverPhaseConfig;
